/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/10/2022
 */

import NoteItem from "@shared/Profile/NoteItem";

import {Type} from "class-transformer"
import BaseObject from "@shared/BaseObject";

export default class WheelSegmentItem extends BaseObject{


	value: number = null
	valueFuture: number = null
	label: string = null
	color: string = null

	@Type(() => NoteItem)
	noteList: NoteItem[] = []
	description: string = null

	constructor(label: string, value: number, color: string) {
		super();
		this.value = value;
		this.label = label;
		this.color = color;
		this.valueFuture = 0
	}

	hasNote(){
		return this.noteList.length > 0
	}
	getNote(join = "\n"){
		return this.noteList.map(note => note.text).join(join)
	}

	reset(){
		this.value = null
		this.valueFuture = null
	}

	getGat(){
		return Math.max(this.valueFuture - this.value, 0)
	}

	getValueFuture(){
		return Math.max(this.valueFuture , this.value)
	}

	hasNotes(){
		return this.noteList.length > 0
	}
}



